import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import data from './earnings-history/earnings-history';

const earningsHistory = combineReducers({
  data,
  isLoading: loadingStatusAccordingToReducer('earningsHistoryLoadingStatus'),
});

export default earningsHistory;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/earnings-history.reducer.js